import { debounce } from '../../core/helpers';

// Filter nav sticks to the main nav after scrolling to a certain position
const filterNavPosition = () => {
  const collectionGrid = document.querySelector('[data-collection-grid]');
  if (!collectionGrid || collectionGrid.dataset.filterBarFixed !== 'true') {
    return;
  }

  const filtersPanels = document.querySelectorAll('[data-filters-panel-v3]'); // PLP and Search overlay
  const desktopNav = document.querySelector('[data-main-nav]');
  const mobileNav = document.querySelector('.main-nav--mobile');
  const fullHeader = (window.theme.breakpoints.current === 'mobile') ? document.querySelector('.shopify-section.header .main-nav--mobile') : document.querySelector('.shopify-section.header .main-nav--desktop');
  const productsElement = document.querySelector('[data-products]');

  if (!filtersPanels.length || !fullHeader || !productsElement) {
    return;
  }

  const windowTop = window.scrollY;
  const productsTop = productsElement.getBoundingClientRect().top + window.scrollY;

  let navHeight = 0;
  if (window.theme.breakpoints.current === 'mobile') {
    if (mobileNav) {
      navHeight = mobileNav.offsetHeight;
    }
  } else if (desktopNav) {
    navHeight = desktopNav.offsetHeight;
  }

  filtersPanels.forEach(panel => {
    const posCheck = productsTop - navHeight;
    // console.log('windowTop', windowTop, 'posCheck', posCheck);
    if (posCheck <= windowTop) {
      panel.classList.add('sticky');
      productsElement.style.paddingTop = `${panel.offsetHeight}px`; // avoid the jump effect
    } else {
      panel.classList.remove('sticky');
      productsElement.style.paddingTop = '0';
    }
  });
};

export default () => {
  const collectionGrid = document.querySelector('[data-collection-grid]');

  if (collectionGrid?.dataset.filterBarFixed === 'true') {
    // Keep the filter nav sticky below the main nav
    window.addEventListener('scroll', filterNavPosition);

    window.addEventListener('scroll', debounce(filterNavPosition, 100));
    window.addEventListener('resize', debounce(filterNavPosition, 100));

    window.dispatchEvent(new Event('scroll'));
  }
};
